module.exports = __webpack_public_path__ + "c2caaad796f2a1e1d10c4dc362358e2d.svg";